import React from "react";

const ProfileStrip = ({ data }) => {
  const {
    office,
    constituency,
  } = data || {};

  // Prevent errors while API data is loading
  if (!office || !constituency) {
    return null;
  }

  const profileItems = [
    
    [
      "01",
      "POSITION",
      office.position,
      office.office,
    ],

    [
      "02",
      "CONSTITUENCY",
      office.constituency || constituency.constituency,
      constituency.state,
    ],

    [
      "03",
      "LOCATION",
      constituency.ward,
      constituency.town,
    ],

    [
      "04",
      "TENURE",
      `${office.start_year || ""} — ${office.end_year || ""}`,
      office.institution_value,
    ],
  ];

  return (
    <section
      className="profile-strip"
      aria-label="Profile summary"
    >
      <div className="container profile-grid">
      

        {profileItems.map(
          ([num, label, title, desc]) => (
            <article
              className="profile-card"
              key={num}
            >
              <span className="profile-number">
                {num}
              </span>

              <div>
                <small>{label}</small>

                <strong>{title}</strong>

                <p>{desc}</p>
              </div>
            </article>
          )
        )}

      </div>
    </section>
  );
};

export default ProfileStrip;